import { useState } from 'react';
import { useDesignStore } from '@/state/store';
import { Segmented } from '../components/Controls';
import { PackTab } from './PackTab';
import { ImageTab } from './ImageTab';
import { PromptTab } from './PromptTab';
import { LayersTab } from './LayersTab';

/**
 * Step 1 — where the relief comes from.
 *
 * Three ways in (pack, image, prompt) and one way to refine (layers). All four
 * write the same layer stack, so switching between them is never a mode change
 * and nothing is lost on the way.
 */

type TextureTab = 'pack' | 'image' | 'prompt' | 'layers';

const TABS = [
  { value: 'pack', label: 'Pack', help: 'Curated starting points.' },
  { value: 'image', label: 'Image', help: 'Turn your own picture into relief.' },
  { value: 'prompt', label: 'Prompt', help: 'Describe the surface you want.' },
  { value: 'layers', label: 'Layers', help: 'Stack and tune patterns by hand.' },
] as const;

export function TextureStep() {
  const source = useDesignStore((state) => state.design.source);
  const [tab, setTab] = useState<TextureTab>('pack');

  return (
    <div className="step">
      <header className="step__header">
        <h2 className="step__title">Texture</h2>
        <p className="step__subtitle">
          Currently: <strong>{source.label}</strong>
        </p>
      </header>

      <Segmented<TextureTab> value={tab} options={TABS} onChange={setTab} />

      <div className="step__body">
        {tab === 'pack' ? <PackTab /> : null}
        {tab === 'image' ? <ImageTab /> : null}
        {tab === 'prompt' ? <PromptTab /> : null}
        {tab === 'layers' ? <LayersTab onRequestImage={() => setTab('image')} /> : null}
      </div>
    </div>
  );
}
